var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      class: { "custom-padding": _vm.padding },
      attrs: {
        "md-active": _vm.active,
        "md-close-on-esc": false,
        "md-click-outside-to-close": false,
        "data-notif-id": _vm.values.notif_id
      },
      on: {
        "update:mdActive": function($event) {
          _vm.active = $event
        },
        "update:md-active": function($event) {
          _vm.active = $event
        }
      }
    },
    [
      _vm.isLoading
        ? _c("md-progress-bar", { attrs: { "md-mode": "indeterminate" } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isRefundFormShow
        ? [
            _c("md-dialog-title", [
              _vm._v(_vm._s(_vm.i18n.lbl_aml_title_large()))
            ]),
            _vm._v(" "),
            _vm.values.status
              ? _c("detail", {
                  attrs: {
                    prop: _vm.i18n.lbl_status(),
                    bold: _vm.isShowStatus,
                    capitalize: true,
                    value: _vm.values.status,
                    valueTextColor: _vm.isShowStatus ? "red" : "$col-text"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.values.reason
              ? _c("detail", {
                  attrs: {
                    prop: _vm.i18n.lbl_reason(),
                    value: _vm.capitalizeReason,
                    valueTextColor: _vm.isShowStatus ? "red" : "$col-text"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.values.timeStamp
              ? _c("detail", {
                  attrs: {
                    prop: _vm.i18n.lbl_time_optional(),
                    value: _vm.values.timeStamp
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.values.wallet
              ? _c("detail", {
                  attrs: {
                    prop: _vm.i18n.lbl_wallet(),
                    value: _vm.values.wallet,
                    copiable: true
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.values.hash
              ? _c("detail", {
                  attrs: {
                    prop: _vm.i18n.lbl_hash(),
                    value: _vm.values.hash,
                    copiable: true
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.values.asset
              ? _c("detail", {
                  attrs: { prop: _vm.i18n.lbl_asset(), value: _vm.formatToken }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.values.amount
              ? _c("detail", {
                  attrs: { prop: _vm.i18n.lbl_amount(), value: _vm.amount }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.values.order_no
              ? _c("detail", {
                  attrs: {
                    prop: _vm.i18n.lbl_order_id(),
                    value: _vm.values.order_no,
                    copiable: true
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.values.order_amount
              ? _c("detail", {
                  attrs: {
                    prop: _vm.i18n.lbl_order_amount(),
                    value: _vm.orderAmount
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.values.order_network
              ? _c("detail", {
                  attrs: {
                    prop: _vm.i18n.lbl_order_network(),
                    value: _vm.values.order_network
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.values.error
              ? _c("detail", {
                  attrs: {
                    prop: _vm.i18n.lbl_reason(),
                    value: _vm.values.error
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.amlValues && !_vm.isShowStatus
              ? _c("Aml", {
                  attrs: {
                    score: _vm.riskScore,
                    values: _vm.amlValues,
                    higthRisk: _vm.higthRisks
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.values.type === 2
              ? _c(
                  "md-dialog-actions",
                  [
                    _vm.isShowRefund
                      ? _c(
                          "md-button",
                          {
                            staticClass:
                              "md-button btn md-primary md-theme-default",
                            attrs: { disabled: _vm.isLoading },
                            on: { click: _vm.getRefundStatus }
                          },
                          [_vm._v(_vm._s(_vm.i18n.lbl_refund()))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.deposit }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_deposit_white()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.depositDirty }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_credit_dirty()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.postpone }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_put_aside()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default md-yellow",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.checkManual }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_check_crystal()))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.values.type === 3
              ? _c(
                  "md-dialog-actions",
                  [
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.withdrawal }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_deposit()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.cencelWithdrawal }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default md-yellow",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.checkManual }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_check_crystal()))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.values.type === -1
              ? _c(
                  "md-dialog-actions",
                  [
                    _vm.isShowRefund
                      ? _c(
                          "md-button",
                          {
                            staticClass:
                              "md-button btn md-primary md-theme-default",
                            attrs: { disabled: _vm.isLoading },
                            on: { click: _vm.getRefundStatus }
                          },
                          [_vm._v(_vm._s(_vm.i18n.lbl_refund()))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.deposit }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_deposit_white()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.depositDirty }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_credit_dirty()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.checkAgaingDeposit }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_check_again()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.postpone }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_put_aside()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default md-yellow",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.checkManual }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_check_crystal()))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.values.type === -2
              ? _c(
                  "md-dialog-actions",
                  [
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.withdrawal }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_deposit()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.cencelWithdrawal }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.checkAgaingWithdrawal }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_check_again()))]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-button btn md-primary md-theme-default md-yellow",
                        attrs: { disabled: _vm.isLoading },
                        on: { click: _vm.checkManual }
                      },
                      [_vm._v(_vm._s(_vm.i18n.lbl_check_crystal()))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.error
              ? _c("p", { staticClass: "text-center error" }, [
                  _vm._v(_vm._s(_vm.i18n.lbl_something_wrong()))
                ])
              : _vm._e()
          ]
        : [
            _c("RefundModal", {
              attrs: {
                token: _vm.formatToken,
                isLoading: _vm.isLoading,
                status: _vm.refundStatus,
                values: _vm.values
              },
              on: {
                deleteNotif: _vm.deleteNotif,
                refreshStatus: _vm.getRefundStatus,
                close: _vm.toggleRefund,
                setIsLoading: _vm.setIsLoading,
                toggleError: _vm.toggleError
              }
            })
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c1d44e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c1d44e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/navigation/AmlDialog.vue
// module id = z/jD
// module chunks = 1